import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { TranslationProvider, useTranslation } from '@ibk/shared-translation';
import { beneficiosTranslations } from '../../../../translations';
import { HiringFeedbackLayout, useIsEmissorFeedbackFlow } from '../HiringFeedback';
import styles from './HiringActivation.module.css';
function HiringActivationContent({ onGoToBenefits }) {
    const { t } = useTranslation();
    const isEmissorFlow = useIsEmissorFeedbackFlow();
    return (_jsx(HiringFeedbackLayout, { iconName: 'circleCheckmark', iconAlt: t('activation.success.iconAlt'), iconClassName: styles.successIcon, iconContainerClassName: `${styles.iconContainer} ${styles.successIconContainer}`, title: t(isEmissorFlow ? 'activation.success.emissor.title' : 'activation.success.title'), description: t(isEmissorFlow ? 'activation.success.emissor.description' : 'activation.success.description'), buttonLabel: t('activation.success.button'), onGoToBenefits: onGoToBenefits }));
}
export function HiringActivation({ onGoToBenefits }) {
    return (_jsx(TranslationProvider, { translations: beneficiosTranslations, defaultLanguage: 'pt-BR', children: _jsx(HiringActivationContent, { onGoToBenefits: onGoToBenefits }) }));
}
